import { eventRecommendationEndpoint, apiKey } from "./constants";
/**
 * Call the V2 Product Recommendation Lambda API
 * @param {Object} params
 * @param {string} params.userObjectId - User's object ID
 * @param {string} params.clientObjectId - Client's object ID
 * @param {string} params.feature - Feature name (default: 'product-recommendation')
 * @param {Object} params.factsheets - Client factsheets data (age, income, etc.)
 * @param {Array} params.portfolios - Client's existing insurance portfolios
 * @param {Object} params.clientTraits - Client traits/personality data
 * @param {string} params.language - Language for response (e.g., 'zh-Hant-HK')
 * @param {number} params.topN - Number of products to recommend (default: 5)
 * @param {boolean} params.returnPrompt - Whether to return the prompt in response
 * @returns {Promise<Object>} API response with products array
 */
export const getEventRecommendation = async ({
  userObjectId,
  clientObjectId,
  feature = "event-recommendation",
  factsheets = {},
  portfolios = [],
  clientTraits = {},
  language = "zh-Hant-HK",
  topN = 5,
  returnPrompt = false,
  startDate,
  endDate
}) => {
  if (!eventRecommendationEndpoint || !apiKey) {
    throw new Error(
      "Event Recommendation API endpoint or API key not configured"
    );
  }
  const body = {
    userObjectId,
    clientObjectId,
    feature,
    factsheets,
    portfolios,
    clientTraits,
    language,
    topN,
    returnPrompt
  };

  if(startDate){
    body.dateFrom = startDate;
  }
  if(endDate){
    body.dateTo = endDate;
  }

  const req = {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      "X-API-Key": apiKey
    }
  };

  console.log("Event Recommendation API: Request ::: ", req);
  const response = await fetch(eventRecommendationEndpoint, req);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`API request failed: ${response.status} - ${errorText}`);
  }

  const result = await response.json();
  console.log("Event Recommendation API: Result ::: ", result);

  if (result.error) {
    throw new Error(result.error);
  }

  return result;
};
